import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './GeneralCardIconCards.css';
import React from 'react';
import { canUseDOM, get, getPageThemeColors } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { DefaultCards } from './components/DefaultCards';
import { StickyCards } from './components/StickyCards';
import { RectangularCards } from './components/RectangularCards';
import { isNil } from '../../utils/IsNil';
import { hexToRgb } from '../../utils/hexToRgb';
export var EGeneralCardsIconTypes = /*#__PURE__*/function (EGeneralCardsIconTypes) {
  EGeneralCardsIconTypes["Default"] = "Default";
  EGeneralCardsIconTypes["Rectangular"] = "Rectangular";
  EGeneralCardsIconTypes["Sticky"] = "Sticky";
  return EGeneralCardsIconTypes;
}({});
export var GeneralCardIconCards = function GeneralCardIconCards(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields) {
    console.info('GeneralCardIconCards component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [GeneralCardIconCards component is empty: please provide data source]");
    }
    return null;
  }
  var cardVariant = get(params, 'variant');
  var isCardBackgroundWhite = get(params, 'isCardBackgroundWhite');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var variables = BackgroundColorHex ? {
    '--general-card-icon-background-color': isCardBackgroundWhite ? "#fff" : "#F4F4F4",
    '--general-card-icon-color': BackgroundColorHex,
    '--general-card-icon-color-with-opacity': isCardBackgroundWhite ? hexToRgb(BackgroundColorHex).concat(", 0.1") : hexToRgb("#fff").concat(", 1")
  } : {
    '--general-card-icon-background-color': isCardBackgroundWhite ? "#fff" : "#F4F4F4",
    '--general-card-icon-color': selectedPrimaryColor,
    '--general-card-icon-color-with-opacity': isCardBackgroundWhite ? hexToRgb(selectedPrimaryColor).concat(", 0.1") : hexToRgb("#fff").concat(", 1")
  };
  var generalCardsIconMap = {
    "Default": /*#__PURE__*/React.createElement(DefaultCards, {
      fields: fields,
      params: params
    }),
    "Rectangular": /*#__PURE__*/React.createElement(RectangularCards, {
      fields: fields,
      params: params
    }),
    "Sticky": /*#__PURE__*/React.createElement(StickyCards, {
      fields: fields,
      params: params
    })
  };
  if (isNil(generalCardsIconMap[cardVariant])) {
    console.warn("component with \"".concat(cardVariant, "\" variant is not defined, try to use of this options ").concat(Object.values(EGeneralCardsIconTypes)));
    return null;
  }
  var componentBackgroundColor = isCardBackgroundWhite ? "#F4F4F4" : "#fff";
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    style: _objectSpread(_objectSpread({}, variables), {}, {
      background: componentBackgroundColor
    }),
    anchorUrlParameter: params['Anchor Url Parameter']
  }, generalCardsIconMap[cardVariant]);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className,
    anchorUrlParameter = _ref2.anchorUrlParameter,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    style: style,
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, children);
};
var commonStyles = "c1qb6w9g";
var ltrStyles = "l1qr1ocu";
var rtlStyles = "rqhntxl";
export default GeneralCardIconCards;